import React, { Fragment } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styles from "./index.module.css";
const ShimmerLoader = () => {
  return (
    <Fragment>
      <Skeleton
        height={500}
        width="100%"
        className={styles.shimmerLoaderWrapper}
      />
    </Fragment>
  );
};

export default ShimmerLoader;
